import { useDisclosure } from "@mantine/hooks";

/**
 * Custom hook to manage all modal states in Regtank component
 * Consolidates 8 different modal states into a single hook
 */
export const useRegtankModals = () => {
  const [openedRegtankOnboarding, regtankOnboardingHandlers] = useDisclosure();
  const [openedLiveness, livenessHandlers] = useDisclosure();
  const [openedDocument, documentHandlers] = useDisclosure();
  const [openedImageModal, imageModalHandlers] = useDisclosure();
  const [openedVerificationAppr, verificationApprHandlers] = useDisclosure();
  const [openedVerificationReject, verificationRejectHandlers] = useDisclosure();

  return {
    // Onboarding modal
    openedRegtankOnboarding,
    openRegtankOnboarding: regtankOnboardingHandlers.open,
    closeRegtankOnboarding: regtankOnboardingHandlers.close,
    toggleRegtankOnboarding: regtankOnboardingHandlers.toggle,

    // Liveness modal
    openedLiveness,
    openLiveness: livenessHandlers.open,
    closeLiveness: livenessHandlers.close,
    toggleLiveness: livenessHandlers.toggle,

    // Document modal
    openedDocument,
    openDocument: documentHandlers.open,
    closeDocument: documentHandlers.close,
    toggleDocument: documentHandlers.toggle,

    // Image modal (for liveness photos/videos)
    openedImageModal,
    openImageModal: imageModalHandlers.open,
    closeImageModal: imageModalHandlers.close,
    toggleImageModal: imageModalHandlers.toggle,

    // Verification approval modal
    openedVerificationAppr,
    openVerificationAppr: verificationApprHandlers.open,
    closeVerificationAppr: verificationApprHandlers.close,
    toggleVerificationAppr: verificationApprHandlers.toggle,

    // Verification rejection modal
    openedVerificationReject,
    openVerificationReject: verificationRejectHandlers.open,
    closeVerificationReject: verificationRejectHandlers.close,
    toggleVerificationReject: verificationRejectHandlers.toggle,
  };
};
